var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _rect2, _rect3, _rect4, _rect5, _g2, _rect6, _rect7, _rect8, _rect9, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyncInfoBanner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 204,
  height: 120,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 119.209,
  height: 99.585,
  x: 42.269,
  y: 10.269,
  fill: "#fff",
  stroke: "#ECECEC",
  strokeWidth: 1.463,
  rx: 3.535
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7E92",
  d: "M49.308 19.41a2.103 2.103 0 1 0 0-4.205 2.103 2.103 0 0 0 0 4.205"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD05B",
  d: "M56.317 19.41a2.103 2.103 0 1 0 0-4.205 2.103 2.103 0 0 0 0 4.205"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#98DB7C",
  d: "M63.325 19.41a2.103 2.103 0 1 0 0-4.205 2.103 2.103 0 0 0 0 4.205"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M127.105 15.205h-56.07a2.103 2.103 0 1 0 0 4.205h56.07a2.102 2.102 0 0 0 0-4.205"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M154.438 15.205h-19.624a2.103 2.103 0 0 0 0 4.205h19.624a2.102 2.102 0 1 0 0-4.205"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M152.336 25.018H51.41c-.774 0-1.401.627-1.401 1.401v15.42c0 .774.627 1.401 1.401 1.401h100.926c.774 0 1.401-.627 1.401-1.401v-15.42c0-.774-.627-1.401-1.401-1.401"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8E9EB",
  d: "M68.231 46.044h-16.82c-.775 0-1.403.628-1.403 1.402v53.266c0 .774.628 1.402 1.402 1.402h16.821c.774 0 1.402-.628 1.402-1.402V47.446c0-.774-.628-1.402-1.402-1.402M152.336 46.044H73.838c-.774 0-1.402.628-1.402 1.402v2.102c0 .774.628 1.402 1.402 1.402h78.498c.774 0 1.401-.628 1.401-1.402v-2.102c0-.774-.627-1.402-1.401-1.402M89.257 53.753H73.838c-.774 0-1.402.627-1.402 1.402v15.419c0 .774.628 1.402 1.402 1.402h15.42c.773 0 1.401-.628 1.401-1.402v-15.42c0-.774-.628-1.401-1.402-1.401M110.283 53.753H94.864c-.774 0-1.402.627-1.402 1.402v15.419c0 .774.628 1.402 1.402 1.402h15.419c.774 0 1.402-.628 1.402-1.402v-15.42c0-.774-.628-1.401-1.402-1.401M131.31 53.753h-15.42c-.774 0-1.401.627-1.401 1.402v15.419c0 .774.627 1.402 1.401 1.402h15.42c.774 0 1.401-.628 1.401-1.402v-15.42c0-.774-.627-1.401-1.401-1.401M152.336 53.753h-15.419c-.775 0-1.402.627-1.402 1.402v15.419c0 .774.627 1.402 1.402 1.402h15.419c.774 0 1.401-.628 1.401-1.402v-15.42c0-.774-.627-1.401-1.401-1.401M89.257 74.78H73.838c-.774 0-1.402.627-1.402 1.401v15.42c0 .773.628 1.4 1.402 1.4h15.42c.773 0 1.401-.627 1.401-1.4V76.18c0-.774-.628-1.402-1.402-1.402M110.283 74.78H94.864c-.774 0-1.402.627-1.402 1.401v15.42c0 .773.628 1.4 1.402 1.4h15.419c.774 0 1.402-.627 1.402-1.4V76.18c0-.774-.628-1.402-1.402-1.402M131.31 74.78h-15.42c-.774 0-1.401.627-1.401 1.401v15.42c0 .773.627 1.4 1.401 1.4h15.42c.774 0 1.401-.627 1.401-1.4V76.18c0-.774-.627-1.402-1.401-1.402M152.336 74.78h-15.419c-.775 0-1.402.627-1.402 1.401v15.42c0 .773.627 1.4 1.402 1.4h15.419c.774 0 1.401-.627 1.401-1.4V76.18c0-.774-.627-1.402-1.401-1.402"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M118.694 97.207h-11.915c-.774 0-1.401.628-1.401 1.402v2.102a1.4 1.4 0 0 0 1.401 1.402h11.915c.774 0 1.402-.627 1.402-1.402v-2.102c0-.774-.628-1.402-1.402-1.402M101.172 97.207H99.07c-.775 0-1.402.628-1.402 1.402v2.102c0 .775.627 1.402 1.402 1.402h2.102c.774 0 1.402-.627 1.402-1.402v-2.102c0-.774-.628-1.402-1.402-1.402M126.404 97.207h-2.103c-.774 0-1.402.628-1.402 1.402v2.102c0 .775.628 1.402 1.402 1.402h2.103a1.4 1.4 0 0 0 1.401-1.402v-2.102c0-.774-.627-1.402-1.401-1.402"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M47.105 23.402c0-.774.627-1.402 1.401-1.402h109.598v81.598c0 .774-.627 1.402-1.401 1.402H47.105z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M144.289 60.037c0-11.226-9.254-20.358-20.628-20.358-1.794 0-3.569.226-5.274.67l-3.673.957-1.63-3.387C110.186 31.894 103.96 28 97.224 28 87.55 28 79.68 35.767 79.68 45.315v6.064h-6.313C60.613 51.38 50.073 61.47 50 74.057 49.927 86.695 60.323 97 73.112 97h67.994C150.437 97 158 89.535 158 80.327c0-8.046-6.09-14.684-13.968-15.68l.215-3.34c.028-.424.042-.851.042-1.27"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-info-banner_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 62,
  x: 145,
  y: 10,
  fill: "#fff",
  rx: 2
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 35,
  x: 149,
  y: 13,
  fill: "#E4E4E4",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 3,
  x: 149,
  y: 52,
  fill: "#E4E4E4",
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 3,
  x: 149,
  y: 57,
  fill: "#E4E4E4",
  rx: 1.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 3,
  x: 149,
  y: 62,
  fill: "#E4E4E4",
  rx: 1.5
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sync-info-banner_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 62,
  x: 13,
  y: 37,
  fill: "#fff",
  rx: 2
}))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 35,
  x: 17,
  y: 40,
  fill: "#E4E4E4",
  rx: 2
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 3,
  x: 17,
  y: 79,
  fill: "#E4E4E4",
  rx: 1.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 3,
  x: 17,
  y: 84,
  fill: "#E4E4E4",
  rx: 1.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 3,
  x: 17,
  y: 89,
  fill: "#E4E4E4",
  rx: 1.5
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#73C0AE",
  d: "M166 107.212a2.21 2.21 0 0 0 2.212 2.212 2.21 2.21 0 0 0 2.212-2.212 2.21 2.21 0 0 0-2.212-2.212 2.21 2.21 0 0 0-2.212 2.212M24 11a1 1 0 1 0 1.999.001A1 1 0 0 0 24 11M9 35a1 1 0 1 0 1.999.001A1 1 0 0 0 9 35M198 71a1 1 0 1 0 1.999.001A1 1 0 0 0 198 71"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3F3F",
  d: "M103.795 51.484c3.579 0 6.969 1.17 9.771 3.298l-6.486 6.106 16.496 1.769-.775-16.572-6.577 6.194a19.64 19.64 0 0 0-12.429-4.395C92.881 47.885 84 56.766 84 67.68h3.599c0-8.93 7.265-16.196 16.196-16.196M103.794 83.874c-3.58 0-6.97-1.17-9.772-3.298l6.486-6.106-16.496-1.769.775 16.572 6.577-6.194a19.64 19.64 0 0 0 12.43 4.394c10.914 0 19.794-8.88 19.794-19.794h-3.599c0 8.93-7.265 16.195-16.195 16.195"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7FFED",
  d: "M103.795 48.399c3.579 0 6.969 1.17 9.771 3.298l-6.486 6.106 16.496 1.769L122.801 43l-6.577 6.194a19.64 19.64 0 0 0-12.429-4.395C92.881 44.8 84 53.68 84 64.595h3.599c0-8.93 7.265-16.195 16.196-16.195M103.794 80.79c-3.58 0-6.97-1.17-9.772-3.3l6.486-6.105-16.496-1.769.775 16.572 6.577-6.194a19.64 19.64 0 0 0 12.43 4.394c10.914 0 19.794-8.88 19.794-19.794h-3.599c0 8.93-7.265 16.195-16.195 16.195"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "sync-info-banner_svg__a",
  width: 44,
  height: 64,
  x: 145,
  y: 10,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.882353 0 0 0 0 0.890196 0 0 0 0 0.898039 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13769_26360"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13769_26360",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "sync-info-banner_svg__b",
  width: 44,
  height: 64,
  x: 13,
  y: 37,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.882353 0 0 0 0 0.890196 0 0 0 0 0.898039 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13769_26360"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13769_26360",
  result: "shape"
})))));
export { SvgSyncInfoBanner as ReactComponent };
export default __webpack_public_path__ + "static/media/sync-info-banner.610ae640.svg";